export class FolderNameTokenDTO {
  key: string;

  formats?: string[];

  sample: string;

  constructor() {
    this.key = '';
    this.sample = '';
  }
}

export class OutputLocationBindingInheritanceDTO {
  list: boolean;

  folderRule: boolean;

  format: boolean;

  constructor() {
    this.list = true;
    this.folderRule = true;
    this.format = true;
  }
}

export class OutputLocationBindingEffectiveDTO {
  listId?: number;

  folderDriveItemId?: string;

  folderName?: string;

  folderRule: number;

  folderNameFormat: string;

  constructor() {
    this.folderRule = 0;
    this.folderNameFormat = '';
  }
}

export class OutputLocationBindingDTO {
  bindingId?: number;

  scope: number;

  templateTaskId?: number;

  templateName?: string;

  templateTaskType?: number;

  listId?: number;

  listName?: string;

  listUrl?: string;

  providerType?: number;

  folderDriveItemId?: string;

  folderName?: string;

  folderRule?: number;

  folderNameFormat?: string;

  inherited: OutputLocationBindingInheritanceDTO;

  effective: OutputLocationBindingEffectiveDTO;

  constructor() {
    this.scope = 0;
    this.inherited = new OutputLocationBindingInheritanceDTO();
    this.effective = new OutputLocationBindingEffectiveDTO();
  }
}

export class OutputLocationBindingsDTO {
  default: OutputLocationBindingDTO;

  templates: OutputLocationBindingDTO[];

  tokens: FolderNameTokenDTO[];

  constructor() {
    this.default = new OutputLocationBindingDTO();
    this.templates = [];
    this.tokens = [];
  }
}

/** The body of PUT settings/outputlocations/{purpose}/bindings/default. */
export class OutputLocationDefaultBindingPutDTO {
  folderRule: number | null;

  folderNameFormat: string | null;

  constructor() {
    this.folderRule = null;
    this.folderNameFormat = null;
  }
}

/** The body of PUT settings/outputlocations/{purpose}/bindings/templates/{templateTaskId}; null takes the default. */
export class OutputLocationTemplateBindingPutDTO {
  listId: number | null;

  folderDriveItemId: string | null;

  folderName: string | null;

  folderRule: number | null;

  folderNameFormat: string | null;

  constructor() {
    this.listId = null;
    this.folderDriveItemId = null;
    this.folderName = null;
    this.folderRule = null;
    this.folderNameFormat = null;
  }
}

/** The body of POST settings/outputlocations/{purpose}/bindings/preview. */
export class FolderNamePreviewRequestDTO {
  format: string;

  sampleTaskId: number | null;

  constructor() {
    this.format = '';
    this.sampleTaskId = null;
  }
}

export class FolderNamePreviewDTO {
  levels: string[];

  problems: string[];

  constructor() {
    this.levels = [];
    this.problems = [];
  }
}
